import { TimetablePrintLayoutOptions } from '@bp/planung-graphql-types';
import { Select, SelectOptionType } from '@bp/ui-components';
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import {
  TimetablePrintConfigurationFormType,
  TimetablePrintLayoutPositions,
} from '../forms/TimetablePrintConfigurationForm';
import styles from './TimetablePrintConfigurationGridTile.module.scss';

type TimetablePrintConfigurationGridTileProps = {
  value: TimetablePrintLayoutOptions | null;
  position: TimetablePrintLayoutPositions;
  options: SelectOptionType[];
  isMandatory?: boolean;
  disabled?: boolean;
};

export const TimetablePrintConfigurationGridTile = ({
  value,
  position,
  options,
  isMandatory,
  disabled,
}: TimetablePrintConfigurationGridTileProps) => {
  const { setFieldValue } = useFormikContext<TimetablePrintConfigurationFormType>();

  return (
    <div className={classNames(styles['timetable-print-configuration-grid-tile'], { [styles.mandatory]: isMandatory })}>
      <Select
        isClearable={!isMandatory}
        options={options}
        disabled={disabled}
        defaultValue={options.find((o) => o.value === value)}
        onChange={async (option) => {
          const value = option
            ? ((option as SelectOptionType).value as TimetablePrintLayoutOptions)
            : TimetablePrintLayoutOptions.Empty;
          await setFieldValue(position, value);
        }}
        name={'config-selection'}
        menuPosition='fixed'
      />
    </div>
  );
};
